// extracted by mini-css-extract-plugin
export default {"wrapper":"DashLayoutAdmin_wrapper__rxArZ","main":"DashLayoutAdmin_main__fW5RC","content":"DashLayoutAdmin_content__A6LSz"};